import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError, isAxiosError } from "axios";
import api from "src/http/index";

import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";

import { ContactWithID, ClientWithID, ContactWithOutID, ContactsResponseLength}  from '../../types/request.type';

export const contactsData = createAsyncThunk<ContactWithID[], ClientWithID>(
  "/contactsData",
  async (client, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    try {

      const response = await api.get(`/contacts`, {
        params: client !== undefined && client.id !== 777777 ? {
          client: client.id,
          page: 1,
          qtyPerPage: 10

        } : 
        {
         
          page: 1,
          qtyPerPage: 10

        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);


export const contactsDataPage = createAsyncThunk<ContactsResponseLength, {}>(
  "/contactsDataPage",
  async (obj, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    try {

      var page = Number(Object.values(obj)[0]) + 1;
      var qtyPerPage = Number(Object.values(obj)[1]);
      var client = Object.values(obj)[2] as ClientWithID; 

      const response = await api.get(`/contacts`, {
        params: client !== undefined && client?.id !== 777777 ? {
          client: client.id,
          page: page,
          qtyPerPage: qtyPerPage 

        } : 
        {
          page: page,
          qtyPerPage: qtyPerPage
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);




/*
export const contactsDataPage = createAsyncThunk<ClientsResponseLength, {}>(
  "/clientsDataPage",
  async (obj, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    console.log("===================================")

    var page = Number(Object.values(obj)[0]) + 1;
    var qtyPerPage = Object.values(obj)[1];

    console.log(page +  "   " + qtyPerPage );

    try {
      // configure header's Content-Type as JSON

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        params: {         
          page: page,
          qtyPerPage: qtyPerPage
        },

      };

      const response = await api.get(`/clients`, config);


      console.log(response);

      if (response.status! in [200, 201]) {
        return rejectWithValue("Request ERROR");
      }
      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);
*/







export const contactDataByID = createAsyncThunk<ContactWithID, number>(
  "/contactDataByID",
  async (id, { rejectWithValue, fulfillWithValue }) => {

    try {

      const response = await api.get(`/contacts/${id}`, {
        params: {
          page: 1,
          qtyPerPage: 1000

        }
      });    

      if (response.status! in [200, 201]) {
        return rejectWithValue('Request ERROR');
    }

    return fulfillWithValue(response.data);

    } catch (e) {
      if (isAxiosError(e)) {
          const err = e as AxiosError;
          return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
  }
  }
);




export const contactsDataPost = createAsyncThunk<ContactWithID, ContactWithOutID>(
  "/contactsDataPost",
  async (new_contact, { rejectWithValue, fulfillWithValue }) => {
    const accessToken = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken")
      : null;

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization" : `Bearer ${accessToken}`,
      },
       
    };

    try {

      const response = await api.post(`/contacts`, {
                      
          name: new_contact.name,
          client_id: new_contact.client.id,
          phones: new_contact.phones,
          emails: new_contact.emails,
          position: new_contact.position,
          comment: new_contact.comment
        ,
      }, config);

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);



export const contactsDataUpdate = createAsyncThunk<ContactWithID, ContactWithID>(
  "/contactsDataUpdate",
  async (update_contact, { rejectWithValue, fulfillWithValue }) => {
    
    const accessToken = localStorage.getItem('accessToken')
    ? localStorage.getItem('accessToken')
   : null
    try {
      // configure header's Content-Type as JSON
        const config = {
        headers: {
          "Content-Type": "application/json",
          "Authorization" : `Bearer ${accessToken}`,
        },
         
      };

      const databody = {
        name: update_contact?.name,
        client_id: update_contact?.client.id,
        phones: update_contact?.phones,
        emails: update_contact?.emails,
        position: update_contact?.position,
        comment: update_contact?.comment
      };
   
     const response = await api.patch(`/contacts/${update_contact?.id}`, databody, config);
     
     return fulfillWithValue(response.data);

    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);



export const contactsDataDelete = createAsyncThunk<SuccessResponse, ContactWithID>(
  "/contactsDataDelete",
  async (delete_contact, { rejectWithValue, fulfillWithValue }) => {
    // //data
    const accessToken = localStorage.getItem('accessToken')
    ? localStorage.getItem('accessToken')
   : null
    try {
      // configure header's Content-Type as JSON
        const config = {
        headers: {
          "Content-Type": "application/json",
          "Authorization" : `Bearer ${accessToken}`,
        },
         
      };
   
      const response = await api.delete(`/contacts/${delete_contact?.id}`, config);

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);


export const contactsDataDeleteByID = createAsyncThunk<SuccessResponse, number>(
  "/contactsDataDeleteByID",
  async (delete_contact_id, { rejectWithValue, fulfillWithValue }) => {
    // //data
    const accessToken = localStorage.getItem('accessToken')
    ? localStorage.getItem('accessToken')
   : null
    try {
      // configure header's Content-Type as JSON
        const config = {
        headers: {
          "Content-Type": "application/json",
          "Authorization" : `Bearer ${accessToken}`,
        },
         
      };
   
      const response = await api.delete(`/contacts/${delete_contact_id}`, config);

      return fulfillWithValue(response.data);
    } catch (e) {
      if (isAxiosError(e)) {
        const err = e as AxiosError;
        return rejectWithValue(err.response?.data as ErrorResponse);
      }
      return rejectWithValue("Request ERROR");
    }
  }
);